import AppStarter from './AppStarter';

AppStarter.start();
